export const styles = (theme) => ({
    root: {
      display: "block",
      margin: "0 auto",
      marginLeft: "20px",
      width: 200,
    },
    slider: {
      padding: '22px 0px',
    },
    trackBefore: {
      backgroundColor: theme.palette.secondary.main
    },
    thumb: {
      backgroundColor: theme.palette.secondary.main
    },
    inputLabel: {
      marginTop: theme.spacing.unit,
    },
    inactive: {
      display: "none"
    }
  });


// WEBPACK FOOTER //
// ./src/styles/slider-styles.js